import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import themes from "../theme";

const customStyles = {
  control: provided => ({
    ...provided,
    border: "solid 1px #ccc",
    padding: "1px"
  }),
  indicatorSeparator: () => ({
    display: "none"
  })
};

const Tags = ({ className, ...rest }) => {
  return (
    <div className={className}>
      <AsyncSelect
        styles={customStyles}
        getOptionLabel={option => option && option.displayName}
        getOptionValue={option => option && option.id}
        theme={prevTheme => ({
          ...prevTheme,
          colors: {
            ...prevTheme.colors,
            primary: themes.palette.PRIMARY
          }
        })}
        {...rest}
      />
    </div>
  );
};

Tags.propTypes = {
  className: PropTypes.string
};

Tags.defaultProps = {
  className: ""
};

export const SelectAsync = styled(Tags)`
  .react-autosuggest {
    input {
      padding: 14px;
      width: 100% !important;
      border-radius: 3px;
      border: 1px solid ${({ theme }) => theme.palette.LIGHT_GREY};
      font-size: ${/* istanbul ignore next */ ({ theme }) =>
        theme.fontSize.MEDIUM};
      font-family: ${/* istanbul ignore next */ ({ theme }) =>
        theme.fontFamily.REGULAR};
      line-height: 1em;
      height: 39px;
    }
  }
`;
